<script>
    export let linkedContent;
    export let innerWidth;
    export let updateNoteContent;
    export let navigateToNote;

    $: largeScreen = innerWidth > 640

    function dragMe(node) {
		let moving = false;
		let left = node.getBoundingClientRect().left;
		let top = node.getBoundingClientRect().top;
        const parentNode = node.parentElement;

        function mousemoveListener(e) {
            if (moving) {
                left += e.movementX;
                top += e.movementY;
                parentNode.style.top = `${top}px`;
                parentNode.style.left = `${left}px`;
                parentNode.style.userSelect = 'none';
            }
        }
        function mouseupListener() {
            moving = false;
            parentNode.style.userSelect = 'auto';
        }
        function mousedownListener() {
            moving = true;
        }

		node.addEventListener('mousedown', mousedownListener);
		 
		window.addEventListener('mousemove', mousemoveListener);
		
		window.addEventListener('mouseup', mouseupListener);	
	}

    function getDate(dateString) {
        return new Date(dateString).toLocaleDateString('en-us', { weekday:"long", year:"numeric", month:"short", day:"numeric"});
    }

    function handleNoteLinkClick(content) {
        updateNoteContent();
        navigateToNote(content);
    }
</script>


{#if largeScreen}
    <main class="large-screen-linked-content">
        <div id="linkedContentContainer">
            <div id="linkedContentInnerContainerDragBar" use:dragMe></div>
            <div id="linkedContentInnerContainer" >
                {#each linkedContent as content}
                    <div style="margin-top:20px;">
                        <div style="margin-top:10px;">{getDate(content.date)}</div>
                        {#if content.noteLink}
                            <a href={'#'} on:click="{handleNoteLinkClick(content)}">
                                <div style="margin-top:10px;margin-bottom:10px; font-size: 20px;font-weight:bold;">
                                    {content.title}
                                </div>
                            </a>
                        {:else}
                            <div style="margin-top:10px;margin-bottom:10px; font-size: 20px;font-weight:bold;">
                                {content.title}
                            </div>
                        {/if}
                        {#if content.textBody && !content.link && !content.noteLink}
                            <div style="margin-top:10px;margin-bottom:10px;">{content.textBody}</div>
                        {/if}
                        {#if content.link}
                            <a href="{content.link}" target="_blank">{content.link}</a>
                        {/if}
                        <!-- <div style="margin-top:10px;">{content.userID}</div> -->

                        {#if content.tags}
                            <div style="margin-top:10px;">{content.tags}</div>
                        {/if}
                    </div>
                {/each}
            </div>
        </div>
    </main>
{:else}
    <main class="small-screen-linked-content">

    </main>
{/if}

<style>
    #linkedContentContainer {
        background: rgb(230,230,230);
        position: absolute;
    }
    #linkedContentInnerContainer{
        padding: 20px;
    }
    #linkedContentInnerContainerDragBar {
        cursor: move;
        background-color: darkgray;
        height: 40px;
    }
</style>